export default "__VITE_ASSET__C4W729xE__"